























































import Vue from "vue";

// Vuex
import { mapState } from "vuex";
import { RootState } from "@/store";

// Vue components
import EditSchedule from "@/views/App/ServiceAndUpdates/ScheduleConfiguration/EditSchedule.vue";
import PackageAssociationCard from "./PackageAssociationCard.vue";
import TagAssociationCard from "./TagAssociationCard.vue";
import MainSection from "@/views/App/ServiceAndUpdates/DownloadLogs/MainSection.vue";

// Model
import { Installation } from "@/model/data/Installation";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        EditSchedule,
        PackageAssociationCard,
        TagAssociationCard,
        MainSection,
    },
    data() {
        return {
            ClientPrivileges,
            tab: 0,
        };
    },
    props: {
        installations: Array as () => Installation[],
        canClose: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
        }),
    },
});
